import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { getUserRole } from "../../../helpers/api_helper";
import { toast } from "react-toastify";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  let role;
  try {
    localStorage.removeItem("admin");
    // console.log(user);
    const response = yield call(postJwtLogin, {
      email: user.email,
      password: user.password,
    });
    try {
      if (response.error) {
        toast.error("Invalid credentials");
        yield put(apiError(response.error));
        return;
      }
      if (response) {
        toast.success("Login successful!");
        if (response.admin === true) {
          localStorage.setItem("admin", true);
        }
        localStorage.setItem("authUser", JSON.stringify(response));

        role = response.role;

        yield put(loginSuccess(response));

        if (role) {
          history("/");
        }
      }
    } catch (error) {
      toast.error(error);
      yield put(apiError(error));
    }
  } catch (error) {
    toast.error(error);
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    toast.success("You have successfully logged out!");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    toast.error("Error in logging out.");
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
